var ProcessingStatusType;
(function (ProcessingStatusType) {
    ProcessingStatusType["pending"] = "pending";
    ProcessingStatusType["complete"] = "complete";
    ProcessingStatusType["loaded"] = "loaded";
    ProcessingStatusType["error"] = "error";
    ProcessingStatusType["warning"] = "warning";
    ProcessingStatusType["notfound"] = "notfound";
})(ProcessingStatusType || (ProcessingStatusType = {}));

export { ProcessingStatusType };
//# sourceMappingURL=nlsApiTypes.js.map
